module.exports = __webpack_public_path__ + "static/media/forward_outline_large.571bfda3.svg";